import LogoutIcon from '@mui/icons-material/Logout';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { googleLogout } from '@react-oauth/google';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AxiosConfig from '../../../config/AxiosConfig';
import { setProfile } from '../../states/login/loginSlice';

const UserHeader = (props) => {
  const { profile } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [displayRoles, setDisplayRoles] = useState(false);
  const open = Boolean(anchorEl);

  const handleLogOut = () => {
    AxiosConfig.create('get', `/users/logout`)
      .call()
      .exit()
      .catch((err) => console.error(err));

    handleClose();
    googleLogout();
    dispatch(setProfile(null));
    navigate('/login');
  };

  const handleDisplayRoles = () => {
    setDisplayRoles(!displayRoles);
  };

  const handleShortcuts = () => {
    navigate('/shortcuts');
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {profile?.isActive && (
        <>
          <IconButton
            color="inherit"
            onClick={handleClick}
            // aria-label="manage-account"
          >
            <ManageAccountsRoundedIcon />
          </IconButton>

          <Menu
            id="user-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
              list: {
                // "aria-labelledby": "basic-button",
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-around',
                margin: 1,
              }}
            >
              <Typography noWrap component={'span'}>
                {profile?.firstName} {profile?.lastName}
              </Typography>
            </Box>
            <MenuItem divider disabled />
            <MenuItem
              onClick={handleDisplayRoles}
              sx={{ display: 'flex', justifyContent: 'space-around' }}
            >
              <Typography noWrap component={'span'}>
                Rôle(s)
              </Typography>
            </MenuItem>
            {displayRoles === true
              ? profile?.roles?.map((role) => {
                  return (
                    <MenuItem key={role?._id} disabled>
                      <Typography
                        component={'span'}
                        variant="body"
                        fontSize={12}
                      >
                        {role?.name}
                      </Typography>
                    </MenuItem>
                  );
                })
              : []}
            <MenuItem divider disabled />
            <MenuItem
              onClick={handleShortcuts}
              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              <Typography noWrap component={'span'}>
                Raccourcis
              </Typography>
            </MenuItem>
            <MenuItem divider disabled />
            <MenuItem
              sx={{ display: 'flex', justifyContent: 'space-around' }}
              onClick={handleLogOut}
            >
              Logout {<LogoutIcon />}
            </MenuItem>
          </Menu>
        </>
      )}
    </>
  );
};

export default UserHeader;
